'use client';

import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { AuthQueryOptions } from '@/api';
import type { ReviewFormData } from '@/app/donation/(private)/my/review/_components/ReviewForm';
import { ReviewForm } from '@/app/donation/(private)/my/review/_components/ReviewForm';
import { ReviewItem } from '@/app/donation/(private)/my/review/_components/ReviewItem/ReviewItem';
import { ResponsiveDialog } from '@/components/organism/ResponsiveDialog';
interface DonationReviewEditModalProps {
  reviewId: number | null;
  onClose: () => void;
  onSubmit: (reviewId: number, data: ReviewFormData) => void;
  isSubmitting?: boolean;
}
export const DonationReviewEditModal = t0 => {
  const $ = _c(16);
  const {
    reviewId,
    onClose,
    onSubmit,
    isSubmitting
  } = t0;
  let t1;
  if ($[0] !== reviewId) {
    t1 = AuthQueryOptions["get:/wello/v2/auth/home/gift-review/{reviewId}"]({
      path: {
        reviewId: reviewId ?? 0
      }
    });
    $[0] = reviewId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = reviewId !== null;
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = {
      ...t1,
      enabled: t2,
      select: _temp
    };
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const {
    data: detailData,
    isLoading
  } = useQuery(t3);
  const t4 = reviewId !== null;
  let t5;
  if ($[5] !== detailData || $[6] !== isLoading || $[7] !== isSubmitting || $[8] !== onClose || $[9] !== onSubmit || $[10] !== reviewId) {
    t5 = isLoading ? <div className="flex h-200 items-center justify-center"><p className="text-Gray-550 typo-body3">불러오는 중...</p></div> : detailData ? <div className="flex grow flex-col"><div className="desktop:px-0 desktop:pt-0 px-20 pb-24 pt-28"><ReviewItem title={detailData.productName} institutionName={detailData.institutionName} logoUrl={detailData.institutionLogoUrl} mainImageUrl={detailData.productImageUrl} /></div><ReviewForm key={reviewId} defaultValues={{
        contents: detailData.contents,
        rating: detailData.rating,
        imageUrlList: detailData.fileUrlList
      }} onSubmit={data_0 => onSubmit(reviewId, data_0)} onCancel={onClose} isLoading={isSubmitting} /></div> : null;
    $[5] = detailData;
    $[6] = isLoading;
    $[7] = isSubmitting;
    $[8] = onClose;
    $[9] = onSubmit;
    $[10] = reviewId;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== onClose || $[13] !== t4 || $[14] !== t5) {
    t6 = <ResponsiveDialog opened={t4} onClose={onClose} title={"\uD6C4\uAE30 \uC218\uC815"} drawerType="full" isAppBarHeader={true}>{t5}</ResponsiveDialog>;
    $[12] = onClose;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};
function _temp(data) {
  return data.context;
}